import { render } from "./affTicket.vue?vue&type=template&id=27097718"
import script from "./affTicket.vue?vue&type=script&lang=ts"
export * from "./affTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script